module.exports = __webpack_public_path__ + "img/favorite.4d443d51.svg";